<script setup lang="ts">
import './assets/style.scss'
import { useEvents } from '@/entities/Events'
import { VTableFilter } from '@/shared/ui'
import { useRoute } from 'vue-router'
import { computed, onMounted, watch } from 'vue'
import { useSseConnection } from '@/shared/lib'
import { useAuth } from '@/entities/Auth'

const events = useEvents()
const route = useRoute()
const auth = useAuth()

const objectId = computed(() => route.params.object_id as string)
const { isFetching, refetch } = events.loadData(objectId)

/** Обновляем данные при выборе типа события */
watch(
  () => [events.filter.event_types, route.params.object_id],
  () => events.refetchCallback(),
)

/**
 * Вычисляем класс для строки в зависимости от статуса
 * @param status
 */
const getRowClass = (status: number) => {
  switch (status) {
    case 1:
      return 'error_bg'
    case 2:
      return 'warning_bg'
    default:
      return ''
  }
}

/* Устанавливаем SSE соединение */
const { handler: eventsHandler } = useSseConnection((res: any) => {
  if (
    route.params.type !== 'groups' &&
    res.type &&
    res.type == 'events' &&
    res.content.object &&
    res.content.object.id == route.params.object_id &&
    events.callback
  ) {
    events.callback()
  }
})

watch(
  () => auth.user?.user_id,
  () => {
    if (auth.user) {
      eventsHandler(`/user/${auth.user.user_id}/events`)
    }
  },
  { immediate: true },
)

const { handler: eventsGroupHandler } = useSseConnection(() => {
  if (events.callback) events.callback()
})

watch(
  () => route.params.object_id,
  () => {
    if (auth.user && route.params.type === 'groups') {
      eventsGroupHandler(`/groups/${route.params.object_id}/change`)
    }
  },
  { immediate: true },
)

onMounted(() => {
  events.setCallback(refetch)
})
</script>

<template>
  <VDataTableServer
    v-model:items-per-page="events.filter.per_page"
    v-model:page="events.filter.page"
    :loading="isFetching"
    :headers="events.headers"
    :items="events.data"
    :items-length="events.total"
    :items-per-page-options="events.perPageList"
    :row-props="(row) => ({ class: getRowClass(row.item.event_status) })"
    @update:options="refetch"
  >
    <template v-slot:header.event_type="item">
      <VTableFilter :list="events.eventTypes" v-model="events.filter.event_types">
        {{ item.column.title }}
      </VTableFilter>
    </template>
  </VDataTableServer>
</template>
